import { message } from "antd";

export function isStringTemplate(template) {
  return template?.match(/@\{(\w+)\}/)?.length > 0
}

export function stringTemplate(template, data) {
  return template?.replace(/@\{(\w+)\}/g, (_, field) => data?.[field] ?? '')
}

export function mockResponse(result, field = 'result') {
  return Promise.resolve({ data: { [field]: result } });
}

export const optionByLocale = (list, isLocaleTH, valueField, fieldTH, fieldEN, additionalField) => {
  const labelField = isLocaleTH ? fieldTH : fieldEN;
  return list.map(m => {
    const option = {
      label: isStringTemplate(labelField) ? stringTemplate(labelField, m) : m[labelField],
      value: isStringTemplate(valueField) ? stringTemplate(valueField, m) : m[valueField],
    }
    if (additionalField) {
      for (const field in additionalField) {
        option[field] = additionalField[field](isLocaleTH, m);
      }
    }
    return option;
  });
}

export function convertArrayToObject(array = [], key) {
  return array.reduce((acc, obj) => {
    acc[obj[key]] = obj;
    return acc;
  }, {});
}

export function isEmpty(val) {
  return val === null || val === undefined || val === ''
    || (Array.isArray(val) && val.length === 0);
}

export function escapeRegExp(text) {
  if (!text) return;
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

export const copyTextToClipBoard = (text = '', config = {}) => {
  try {
    const {
      autoFormatJson = false,
      successMsg = 'Copied!',
    } = config

    text = text.trim();
    if (autoFormatJson) text = jsonPretty(text)

    const input = document.createElement('textarea');
    input.innerHTML = text;
    document.body.appendChild(input);
    input.select();
    const result = document.execCommand('copy');
    document.body.removeChild(input);

    message.success(successMsg);
    return result;
  } catch (_) {
    return false
  }
}

export const jsonPretty = (text = '') => {
  try {
    const jsonObj = JSON.parse(text.trim());
    text = JSON.stringify(jsonObj, null, "\t");
  } catch (error) { }
  return text;
}